(() => {
  const formatMoney = (cents) => {
    if (typeof window.GRFormatMoney === "function") {
      return window.GRFormatMoney(cents);
    }
    if (window.Shopify?.formatMoney && window.Shopify?.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return (Number(cents) / 100).toFixed(2);
  };

  const BENEFITS_HTML = `
    <div class="gr-seal-benefits">
      <div class="gr-seal-benefits__item">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
          <path d="M9 8v8M15 8v8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span>EDIT OR CANCEL ANYTIME</span>
      </div>
      <div class="gr-seal-benefits__item">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M17 1l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 11V9a4 4 0 0 1 4-4h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 23l-4-4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 13v2a4 4 0 0 1-4 4H3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>AUTOMATIC SHIPPING</span>
      </div>
    </div>
  `;

  const formatDeliveryLabel = (optionText) => {
    const text = optionText.toLowerCase().trim();
    if (text === "1 month") return "Delivery every month";
    if (text === "2 months") return "Delivery every two months";
    if (text === "3 months") return "Delivery every three months";

    const match = text.match(/^(\d+)\s*(month|months)$/);
    if (match) {
      const count = parseInt(match[1], 10);
      const unit = count === 1 ? "month" : "months";
      return `Delivery every ${count} ${unit}`;
    }

    return `Delivery every ${text}`;
  };

  const getVariants = (form) => {
    const sectionId = form.closest("product-form")?.dataset.sectionId;
    return window.__grVariantData?.[sectionId] || [];
  };

  const getVariant = (form) => {
    const variantId = form.querySelector('input[name="id"]')?.value;
    const variants = getVariants(form);
    return variants.find((variant) => String(variant.id) === String(variantId));
  };

  const getSelectedPlanId = (form) => {
    const hiddenPlan = form.querySelector('input[name="selling_plan"]')?.value;
    if (hiddenPlan) return hiddenPlan;
    return form.querySelector(".sls-select")?.value || null;
  };

  const getSubscriptionPrice = (variant, planId) => {
    const allocation = variant.selling_plan_allocations?.find(
      (entry) => String(entry.selling_plan_id) === String(planId)
    );
    return allocation?.price ?? allocation?.per_delivery_price ?? null;
  };

  const renderOneTimePrice = (variant) => {
    const comparePrice = variant.compare_at_price;
    const finalPrice = variant.price;
    const hasCompare = comparePrice && comparePrice > finalPrice;

    if (hasCompare) {
      return `<span class="gr-seal-price--compare">${formatMoney(comparePrice)}</span><span class="gr-seal-price--final">${formatMoney(finalPrice)}</span>`;
    }

    return `<span class="gr-seal-price--final">${formatMoney(finalPrice)}</span>`;
  };

  const updatePrices = (form) => {
    if (!form?.querySelector(".sealsubs-container")) return;

    const variant = getVariant(form);
    if (!variant) return;

    const planId = getSelectedPlanId(form);
    const subscriptionPriceEl = form.querySelector(
      '.sls-selling-plan-group-price[data-selling-plan-group="0"]'
    );
    const oneTimePriceEl = form.querySelector(".sls-one-time-price");

    if (subscriptionPriceEl && planId) {
      const subscriptionPrice = getSubscriptionPrice(variant, planId);
      if (subscriptionPrice != null) {
        subscriptionPriceEl.textContent = formatMoney(subscriptionPrice);
      }
    }

    if (oneTimePriceEl) {
      oneTimePriceEl.innerHTML = renderOneTimePrice(variant);
    }
  };

  const selectSubscriptionDefault = (form) => {
    const container = form.querySelector(".sealsubs-container");
    if (!container) return;

    const subRadio = container.querySelector('.sls-option[data-type="subscription"]');
    if (subRadio && !subRadio.checked) {
      subRadio.checked = true;
      subRadio.dispatchEvent(new Event("change", { bubbles: true }));

      const roleRadio = subRadio
        .closest(".seal-col-radio")
        ?.querySelector('[role="radio"]');
      roleRadio?.click();
    }

    const subscriptionOption = container.querySelector(
      ".gr-seal-subscription, .sls-option-container:has(.sls-selling-plan-group-options)"
    );
    const oneTimeOption = container.querySelector(
      '.sls-option-container:not(:has(.sls-selling-plan-group-options))'
    );

    subscriptionOption?.classList.add("sls-active");
    oneTimeOption?.classList.remove("sls-active");

    const planInput = form.querySelector('input[name="selling_plan"]');
    const select = form.querySelector(".sls-select");
    if (planInput && select?.value) {
      planInput.value = select.value;
    }

    updatePrices(form);
  };

  const selectDefaultVariant = (form) => {
    const productForm = form.closest("product-form");
    const sectionId = productForm?.dataset.sectionId;
    const variants = window.__grVariantData?.[sectionId];
    const defaultVariant = variants?.[1];

    if (!defaultVariant) return true;

    const variantInput = form.querySelector('input[name="id"]');
    if (String(variantInput?.value) === String(defaultVariant.id)) {
      return true;
    }

    const productInfo = form.closest("product-info");
    const variantSelects = productInfo?.querySelector("variant-selects");
    if (!variantSelects) return false;

    const optionValues = [
      defaultVariant.option1,
      defaultVariant.option2,
      defaultVariant.option3
    ].filter(Boolean);

    let targetInput = null;
    for (const optionValue of optionValues) {
      for (const input of variantSelects.querySelectorAll('input[type="radio"]')) {
        if (input.value === optionValue && !input.disabled) {
          targetInput = input;
          break;
        }
      }
      if (targetInput) break;
    }

    if (!targetInput) return true;

    targetInput.checked = true;
    targetInput.dispatchEvent(new Event("change", { bubbles: true }));
    return false;
  };

  const applyDefaultSelections = (form) => {
    if (form.dataset.grDefaultsApplied === "true") return;

    const productForm = form.closest("product-form");
    const sectionId = productForm?.dataset.sectionId;
    const variants = window.__grVariantData?.[sectionId];
    if (!variants?.[1]) return;

    const defaultVariant = variants[1];
    const finish = () => {
      selectSubscriptionDefault(form);
      form.dataset.grDefaultsApplied = "true";
    };

    const variantReady = selectDefaultVariant(form);
    if (variantReady) {
      finish();
      return;
    }

    if (typeof subscribe === "function" && window.PUB_SUB_EVENTS?.variantChange) {
      const unsubscribe = subscribe(window.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data?.sectionId) !== String(sectionId)) return;
        if (String(data?.variant?.id) !== String(defaultVariant.id)) return;
        unsubscribe();
        finish();
      });

      window.setTimeout(() => {
        if (form.dataset.grDefaultsApplied !== "true") finish();
      }, 1500);
      return;
    }

    window.setTimeout(finish, 500);
  };

  const hideSkeleton = (form) => {
    const loading = form.querySelector(".gr-seal-loading");
    if (!loading || loading.classList.contains("gr-seal-loading--hidden")) return;

    loading.classList.add("gr-seal-loading--hidden");
    loading.querySelector(".gr-seal-skeleton")?.setAttribute("aria-busy", "false");
  };

  const DROPDOWN_ICON_HTML =
    '<span class="gr-seal-select-icon" aria-hidden="true"><svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L0 0H10L5 5Z" fill="#515151"/></svg></span>';

  const styleDropdownIcons = (container) => {
    container.querySelectorAll(".sls-select-container").forEach((wrapper) => {
      wrapper.classList.add("gr-seal-select-wrap");

      if (!wrapper.querySelector(".gr-seal-select-icon")) {
        wrapper.insertAdjacentHTML("beforeend", DROPDOWN_ICON_HTML);
      }

      wrapper.querySelectorAll(".sls-select").forEach((select) => {
        select.style.setProperty("appearance", "none", "important");
        select.style.setProperty("-webkit-appearance", "none", "important");
        select.style.setProperty("-moz-appearance", "none", "important");
        select.style.setProperty("background-image", "none", "important");
        select.style.setProperty("background-color", "transparent", "important");
      });
    });
  };

  const fixSubscriptionLayout = (container) => {
    const subscriptionOption = container.querySelector(
      ".sls-option-container:has(.sls-selling-plan-group-options)"
    );

    if (subscriptionOption) {
      subscriptionOption.classList.add("gr-seal-subscription");

      const sealRow = subscriptionOption.querySelector(":scope > .seal-row");
      const groupOptions = subscriptionOption.querySelector(".sls-selling-plan-group-options");

      if (sealRow && groupOptions && groupOptions.previousElementSibling !== sealRow) {
        sealRow.after(groupOptions);
      }

      const benefitsAnchor = groupOptions || sealRow;
      let benefits = subscriptionOption.querySelector(".gr-seal-benefits");

      if (!benefits && benefitsAnchor) {
        benefitsAnchor.insertAdjacentHTML("afterend", BENEFITS_HTML);
        benefits = subscriptionOption.querySelector(".gr-seal-benefits");
      }

      if (benefits && groupOptions && benefits.previousElementSibling !== groupOptions) {
        groupOptions.after(benefits);
      }
    }

    styleDropdownIcons(container);
  };

  const customizeWidget = (form) => {
    const container = form.querySelector(".sealsubs-container");
    if (!container || container.dataset.grCustomized === "true") return false;

    container.dataset.grCustomized = "true";
    fixSubscriptionLayout(container);

    const label = container.querySelector(".sls-purchase-options-label");
    if (label) label.textContent = "Choose Your Frequency";

    const subscriptionLabel = container.querySelector(
      '.sls-option-container[data-selling-plan-group] .sls-selling-plan-group-name'
    );
    if (subscriptionLabel) subscriptionLabel.textContent = "Subscribe & Save";

    const oneTimeLabel = container.querySelector(
      '.sls-option-container:not([data-selling-plan-group]) .sls-selling-plan-group-name'
    );
    if (oneTimeLabel) oneTimeLabel.textContent = "One Time Purchase";

    const select = container.querySelector(".sls-select");
    if (select && select.dataset.grLabeled !== "true") {
      select.dataset.grLabeled = "true";
      [...select.options].forEach((option) => {
        option.textContent = formatDeliveryLabel(option.textContent);
      });

      select.addEventListener("change", () => {
        window.setTimeout(() => updatePrices(form), 50);
      });
    }

    container.querySelectorAll(".sls-option").forEach((input) => {
      input.addEventListener("change", () => updatePrices(form));
    });

    container.querySelectorAll('[role="radio"]').forEach((radio) => {
      radio.addEventListener("click", () => {
        window.setTimeout(() => updatePrices(form), 50);
      });
    });

    updatePrices(form);
    return true;
  };

  const initForm = (form) => {
    if (!customizeWidget(form)) return;

    const variantInput = form.querySelector('input[name="id"]');
    variantInput?.addEventListener("change", () => updatePrices(form));

    const sectionId = form.closest("product-form")?.dataset.sectionId;
    if (typeof subscribe === "function" && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(window.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data?.sectionId) !== String(sectionId)) return;
        updatePrices(form);
      });
    }
  };

  const scan = () => {
    document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach((form) => {
      const loading = form.querySelector(".gr-seal-loading");
      const container = form.querySelector(".sealsubs-container");

      if (!loading && !container) return;

      if (container) {
        hideSkeleton(form);
        fixSubscriptionLayout(container);
        initForm(form);
        updatePrices(form);
        applyDefaultSelections(form);
      }
    });
  };

  window.GRSealWidget = {
    updatePrices
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  let scanTimer;
  const observer = new MutationObserver(() => {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(scan, 100);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
